import { type FunctionComponent, useState } from "react";
import { useTranslation } from "react-i18next";
import { MileageInput } from "@App/Components/common/MileageInput";
import { SubmitButton } from "@App/Components/atoms/whitelabel/home/SubmitButton";
import { StepWrapper } from "@App/Components/atoms/whitelabel/home/stepper/StepWrapper";
import { ValidationWrapper } from "@App/Components/atoms/forms/ValidationWrapper";

type MileageStepProps = {
  mileage: number | null;
  error?: string | null;
  onSubmit: (mileage: number) => void;
};

export const MileageStep: FunctionComponent<MileageStepProps> = ({
  mileage,
  error,
  onSubmit,
}: MileageStepProps) => {
  const { t } = useTranslation();

  const [tempMileage, setTempMileage] = useState<number | null>(mileage);

  const handleMileageChange = (value: string | number | null) => {
    if (value === "" || value === null) {
      setTempMileage(null);
      return;
    }

    const parsed = Number(value);
    setTempMileage(isNaN(parsed) ? null : parsed);
  };

  return (
    <StepWrapper>
      <ValidationWrapper error={error}>
        <MileageInput value={tempMileage} onChange={handleMileageChange} placeholder="30.000" />
      </ValidationWrapper>
      <SubmitButton
        disabled={tempMileage === null}
        onClick={() => tempMileage !== null && onSubmit(tempMileage)}
        text={t("home.steps.mileage.submitButton.label")}
      />
    </StepWrapper>
  );
};
